import { StrictMode } from "react";

import { LazyHotReloadIndicator } from "@shared/components/LazyHotReloadIndicator/LazyHotReloadIndicator";
import { LazyReactAxe } from "@shared/components/LazyReactAxe/LazyReactAxe";
import { Router } from "@shared/components/Router/Router";
import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary } from "@unauthenticated/signupSignin/components/ErrorBoundary/ErrorBoundary";
import { Providers } from "@unauthenticated/signupSignin/components/Providers/Providers";

import { DirectLabsCheckoutPage, type DirectLabsCheckoutLabItem } from "./DirectLabsCheckoutPage";

interface Props {
  storeAttributes: {
    storeName: string;
    storeSlug: string;
    storeLogo?: string;
  };
  flippers: Flipper[];
  patientId?: string;
  storeId: string;
  ssoErrors?: string;
  analyticsAnonymousId: string;
  labItem: DirectLabsCheckoutLabItem;
}

const DirectLabsCheckoutEntryPoint = ({
  storeAttributes,
  flippers,
  patientId,
  storeId,
  labItem,
  analyticsAnonymousId,
}: Props) => {
  return (
    <StrictMode>
      <Router isRemixHandoffEnabled={flippers.includes("hopper_remix_prac_routing")}>
        <Providers
          currentCountry="US"
          flippers={flippers}
          e2e={false}
          analyticsAnonymousId={analyticsAnonymousId}
        >
          <ErrorBoundary {...{ flippers, roleId: patientId, storeId }}>
            <DirectLabsCheckoutPage
              labItem={labItem}
              storeId={storeId}
              storeSlug={storeAttributes.storeSlug}
            />
          </ErrorBoundary>
        </Providers>
        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </Router>
    </StrictMode>
  );
};

export { DirectLabsCheckoutEntryPoint };
